/**
 * Search a cookie in the document
 * @param name Cookie name
 * @returns Cookie value or null
 */
export const getCookie = (name: string): string | null | undefined => {
  let value = null;
  const cookiesString =
    typeof document !== 'undefined' ? `; ${document.cookie}` : '';
  const cookies: string[] = cookiesString.split(`; ${name}=`);
  if (cookies && cookies.length > 0 && cookies.length >= 2) {
    value = cookies.pop()?.split(';').shift();
  }
  return value;
};

/**
 * Add new cookie to the Document
 * @param  name Cookie name
 * @param  value Cookie value
 * @param  expires Date for cookie expiration
 * @param  path Cookie domain path
 * @param  domain Cookie domain
 */
export const setCookie = (
  name: string,
  value: string | number | boolean,
  expires: Date | null = null,
  path = '/',
  domain: string | null = null
) => {
  const expiresString = expires ? `;expires=${expires}` : '';
  const domainString = domain ? `;domain=${domain}` : '';
  document.cookie = `${name}=${value}${expiresString};path=${path}${domainString}`;
};

/**
 * Remove a cookie from the document
 * @param name Cookie Name
 */
export const removeCookie = (name: string) => {
  if (getCookie(name)) {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
};

export const removeWCCookie = (name: string) => {
  if (getCookie(name)) {
    document.cookie = `${name}=; Path=/; Domain=.cat.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
};

export function getUserActivityCookie(cookieNames: string[]): string[] {
  return cookieNames.filter(
    (name) => name.startsWith('WC_') || name.startsWith('JSESSIONID')
  );
}
